import React from 'react';
import ArticleService from '../../Services/articleService';
import {GetArticleParams} from '../../APIModels/ApiParamsIndex';
import {Avatar, Badge, Breadcrumb, Button, Collapse, DatePicker, Icon, Input, Popover, Radio} from 'antd';
import {Col, Container, Row} from 'reactstrap';
import {FMKArticlesTable} from './FMKArticlesTable';
import queryString from 'query-string';
import CheckboxGroup from "antd/es/checkbox/Group";
import moment from "moment";
import alertService from '../../Services/alertService';
const Panel = Collapse.Panel;

export class FMKArticles extends React.Component
{
    constructor(props) {
        super(props)

        let getParams = queryString.parse(this.props.location.search);

        let param = new GetArticleParams();
        const searchOptions = ['title', 'occhiello', 'summary', 'signature', 'text'];

        let hasFiltersOn = false;

        if (this.props.location.search) {
            param.editionId = getParams.editionId;
            hasFiltersOn = true;
        }

        this.props.showUserBadge(false);

        this.state = {
            articles: null,
            fetchFinish: false,
            param: param,
            paramResponse: null,
            hasFiltersOn: hasFiltersOn,
            modalOpen: false,
            modalTitle: '',
            modalId: '',
            modalContent: '',
            searchValue: '',
            searchOptions: searchOptions,
            searchOptionsDefault: searchOptions,
            selectedRow: []
        }

        this.articleService = new ArticleService(this.props.token);

        this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
        this.handleFiltersKeyPress = this.handleFiltersKeyPress.bind(this);
        this.handleFilters = this.handleFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.deleteArticle = this.deleteArticle.bind(this);
        this.setModal = this.setModal.bind(this);
        this.setPagination = this.setPagination.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onRadioChange = this.onRadioChange.bind(this);
        this.handleDateTimeFromChange = this.handleDateTimeFromChange.bind(this);
        this.handleDateTimeToChange = this.handleDateTimeToChange.bind(this);
        this.selectRow = this.selectRow.bind(this);
        this.setOnline = this.setOnline.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }

    componentDidMount() {

        const paramExist = localStorage.getItem("params")
        let searchValue = "";
        let selectedOptions = [];
        if (paramExist) {
            let jsonParam = JSON.parse(paramExist);
            if(jsonParam.publicationDateFrom)
                jsonParam.publicationDateFrom = moment(jsonParam.publicationDateFrom).format("DD/MM/YYYY");
            if(jsonParam.publicationDateTo)
                jsonParam.publicationDateTo = moment(jsonParam.publicationDateTo).format("DD/MM/YYYY");
            if (jsonParam.title || jsonParam.signature || jsonParam.summary || jsonParam.text || jsonParam.occhiello)
                searchValue = jsonParam.title || jsonParam.signature || jsonParam.summary || jsonParam.text || jsonParam.occhiello;

            //set selected checkboxes
            if (jsonParam.title) selectedOptions.push('title');
            if (jsonParam.occhiello) selectedOptions.push('occhiello');
            if (jsonParam.summary) selectedOptions.push('summary');
            if (jsonParam.signature) selectedOptions.push('signature');
            if (jsonParam.text) selectedOptions.push('text');

            this.setState({ param: jsonParam, searchValue:searchValue, 
                searchOptions: selectedOptions }, (() => this.fetchData()))
            
        }
        else {
            this.fetchData()
        }
        
    }

    fetchData() {
        this.props.loader(true)
        localStorage.setItem("params", JSON.stringify(this.state.param))
        this.articleService.getArticleList(this.state.param)
            .then((response) => {
                this.props.loader(false)
                this.setState({ articles: response.data.data, paramResponse: response.data.params, fetchFinish: true })
            })
            .catch((err) => this.props.loader(false));
    }

    deleteArticle(id, isMassive) {
        if(isMassive){
            this.articleService.deleteArticleMassive(id)
                .then((response) => {
                    if(response.data && response.data.ok){
                        alertService.setAlert('success', 'Articles delete');
                        this.fetchData();
                        this.resetSelected();
                    }
                })
                .catch((err) => console.log(err))
        }else{
            this.articleService.deleteArticle(id)
                .then((response) => {
                    if(response.data && response.data.ok){
                        alertService.setAlert('success', 'Article delete');
                        this.fetchData();
                    }
                })
                .catch((err) => console.log(err))
        }


    }

    handleFiltersKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleFilters();
        }
    }

    handleFilters() {
        this.setState({ hasFiltersOn: true })
        this.fetchData()
    }

    clearFilters() {
        let paramEmpty = new GetArticleParams();
        const searchOptions = this.state.searchOptionsDefault;
        this.setState({ param: paramEmpty,  searchOptions: searchOptions, searchValue: '',  hasFiltersOn: false }, (() => this.fetchData() ))
    }

    setModal(value, title, id, content) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id, modalContent: content })
    }

    setPagination(size, page) {
        let param = new GetArticleParams(this.state.param)
        param.pageSize = size
        param.page = page
        this.setState({ param: param }, (() => this.fetchData()))   
    }


    handleInputFilterChange({ target }) {
        const value = target.value;
        const name = target.name;
        if(name === 'searchValue'){
            this.setState({ searchValue: value}, (() =>   this.onCheckboxChange()))
        }
        else{
            this.setState(prevState => ({
                param: {
                    ...prevState.param,
                    [name]: value
                }
            }))
        }
    }

    onCheckboxChange(event){
        let options = [];
        if(event){
            options = event
            this.setState({searchOptions: event});
        }
        else{
            options = this.state.searchOptions;
        }
        let param = new GetArticleParams();
        param.editionNumber = this.state.param.editionNumber;
        options.forEach(name => {
            param = {...param, [name]: this.state.searchValue}
        })
        this.setState({param: param});
    }

    onRadioChange(event){
        console.log(event)
        const value = event.target.value;

        this.setState(prevState => ({
            param: {
                ...prevState.param,
                isOnline: value
            }
        }))
    }

    handleDateTimeFromChange(value) {
        let date = value ? moment(value).utc().startOf('day') : null;

        this.setState(prevState => ({
            param: {
                ...prevState.param,
                publicationDateFrom: date
            }
        }))
    };

    handleDateTimeToChange(value) {
        let date = value ? moment(value).utc().startOf('day') : null;
        this.setState(prevState => ({
            param: {
                ...prevState.param,
                publicationDateTo: date
            }
        }))
    };

    selectRow(id){
        let selected = this.state.selectedRow;

        if(selected.includes(id))
            selected = selected.filter(i => i !== id)
        else
            selected.push(id)

        this.setState({selectedRow: selected});
    }

    setModalOnline(online) {
        if (online) {
            this.setModal(true, "Publish", this.state.selectedRow, `Set online ${this.state.selectedRow.length} articles.`);
        }
        else {
            this.setModal(true, "Unpublish", this.state.selectedRow, `Set offline ${this.state.selectedRow.length} articles.`);
        }
    }

    setModalDelete() {
        this.setModal(true, "Massive Delete", this.state.selectedRow, `Delete ${this.state.selectedRow.length} articles.`);
    }

    setOnline(ids, isOnline) {
        this.articleService.massiveUpdateStatus({ ids: ids, isOnline: isOnline })
            .then(resp => {
                if(resp.data && resp.data.ok){
                    alertService.setAlert('success', 'Articles update');
                    this.setState({ selectedRow: [] }, () => this.fetchData());
                }
        })
    }

    resetSelected() {
        this.setState({ selectedRow: [] })
    }

    selectAll(){
        const ids = []
        this.state.articles.forEach(a => ids.push(a.id))
        this.setState({ selectedRow: ids })
    }

    onKeyPress(e){
        if(e.key === 'Enter'){
            this.handleFilters()
        }
    }

    render() {

        const options = [
            { label: 'Title', value: 'title' },
            { label: 'Subhead', value: 'occhiello' },
            { label: 'Summary', value: 'summary' },
            { label: 'Signature', value: 'signature' },
            { label: 'Text', value: 'text' },
        ];

        let filter =
            <div className="p-4" onKeyPress={this.onKeyPress}>
                <div className="filterGroup">
                    <Row>
                        <Col sm="12" md="5">
                            <Row>
                                <Col sm="12" className="mb-2">
                                    <CheckboxGroup options={options} className="font-weight-bold" value={this.state.searchOptions} onChange={this.onCheckboxChange} />
                                </Col>
                                <Col sm="12">
                                    <Input autoComplete="new-password" type="text" name="searchValue"
                                           value={this.state.searchValue} className="d-block"
                                           placeholder="Start typing to filter" allowClear={true}
                                           onChange={this.handleInputFilterChange}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="12" md="2">
                            <p className="mb-2 font-weight-bold">Edition Number</p>
                            <Input autoComplete="new-password" type="number" name="editionNumber" value={this.state.param.editionNumber} className="d-block" placeholder="Start typing to filter" allowClear={true} onChange={this.handleInputFilterChange}/>
                        </Col>
                        <Col sm="12" md="5">
                            <p className="mb-2 font-weight-bold">Magazine</p>
                            <Input autoComplete="new-password" type="text" name="magazineName" value={this.state.param.magazineName} className="d-block" placeholder="Start typing to filter" allowClear={true} onChange={this.handleInputFilterChange}/>
                        </Col>
                        <Col sm="12" md="5">
                            <Row>
                                <Col sm="6">
                                    <p className="mb-2 mt-2 font-weight-bold">Date from</p>
                                    <DatePicker format="DD/MM/YYYY" name="competenceDateFrom" value={this.state.param.publicationDateFrom} className="startDatePicker" placeholder="DD/MM/YYYY" onChange={this.handleDateTimeFromChange}/>
                                </Col>
                                <Col sm="6">
                                    <p className="mb-2 mt-2 font-weight-bold">Date to</p>
                                    <DatePicker format="DD/MM/YYYY" name="competenceDateTo"  value={this.state.param.publicationDateTo} className="startDatePicker" placeholder="DD/MM/YYYY" onChange={this.handleDateTimeToChange}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="2">
                            <p className="mb-2 mt-2 font-weight-bold">Status</p>
                            <Radio.Group onChange={this.onRadioChange} style={{width: '100%', justifyContent: 'space-between',display: 'flex'}} value={this.state.param.isOnline}>
                                <Radio value={undefined}>All</Radio>
                                <Radio value={true}>Online</Radio>
                                <Radio value={false}>Offline</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                </div>
                <Row className="justify-content-center mt-4">
                    <Button className="fmk_button" onClick={this.handleFilters} style={{marginLeft: '16px', marginBottom: '10px'}}>Apply</Button>
                    <Button className="fmk_button secondary" onClick={this.clearFilters} style={{ marginLeft: '16px', marginBottom: '10px' }}>Clear filters</Button>
                </Row>
            </div>

        let breadcrumb =
            <Col sm="12" style={{ display: 'inline-flex', height: '0', justifyContent: "end" }}>
                <Breadcrumb className="bread" style={{left: 24}}>
                    <Breadcrumb.Item>
                        <strong className="h5 font-weight-bold" style={{color: 'black'}}>All articles</strong>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="plusButtonCat">
                    <a className="button mr-3" href="/archive/articles/create">
                        <Icon type="plus" /> New Article
                    </a>
                    <a className="button secondary mr-3" href="/archive/articles/import">
                        <Icon type="upload" /> Import massive
                    </a>
                    <Badge>
                        <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                            <div style={{cursor: 'pointer'}}>
                                <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}} icon="user"/>
                            </div>
                        </Popover>
                    </Badge>
                </div>
            </Col>

        let panelTitle = <strong>
            <Icon type="filter" />
            <span className="ml-2">Advanced filters</span>
        </strong>


        const showClearAndNumberResults = this.state.paramResponse && this.state.paramResponse.totalItems !== this.state.paramResponse.totalItemsWithoutFilters

        return (
            <Container fluid={true}>
                <Row style={{minHeight: 'unset'}}>
                    {breadcrumb}
                    <Col sm="12">
                        <Collapse className="mt-4">
                            <Panel className="fmk-collapse" header={panelTitle} key="1">
                                {filter}
                            </Panel>
                        </Collapse>
                    </Col>
                    <Col sm="12" className="mt-0">
                        
                        <Row style={{minHeight: 'unset'}} className="align-items-center">
                            <Col sm="10" className="mt-4 mb-0">
                                
                                {(showClearAndNumberResults) && (
                                    <Button onClick={this.clearFilters} className="mr-3 fmk_button accent">Clear filters</Button>
                                )}
                                {this.state.selectedRow.length == 0 && (
                                    <Button onClick={() => this.selectAll()} className="mr-3 fmk_button secondary"><Icon type="check-square" /> Select all</Button>
                                )}
                                {this.state.selectedRow.length > 0 && (
                                    <div style={{display: "contents"}}>
                                        <Button onClick={() => this.resetSelected()} className="mr-3 fmk_button secondary"><Icon type="close" /> Reset selected</Button>
                                        <Button onClick={() => this.setModalOnline(true)} className="mr-3 fmk_button secondary"><Icon type="check-circle" /> Set online</Button>
                                        <Button onClick={() => this.setModalOnline(false)} className="mr-3 fmk_button secondary"><Icon type="close" /> Set offline</Button>
                                        <Button onClick={() => this.setModalDelete()} className="mr-3 fmk_button secondary"><Icon type="delete" /> Delete</Button>
                                    </div>
                                )}
                            </Col>
                            {(showClearAndNumberResults) && (
                                <Col sm="2" className="text-right mt-4">
                                    <strong>Results: </strong><span>{this.state.paramResponse.totalItems}/{this.state.paramResponse.totalItemsWithoutFilters}</span>
                                </Col>
                            )}
                        </Row>

                        <FMKArticlesTable articles={this.state.articles}
                                          fetchFinish={this.state.fetchFinish}
                                          deleteArticle={this.deleteArticle}
                                          setOnline={this.setOnline}
                                          setModal={this.setModal}
                                          modalOpen={this.state.modalOpen}
                                          modalTitle={this.state.modalTitle}
                                          modalId={this.state.modalId}
                                          modalContent={this.state.modalContent}
                                          paramResponse={this.state.paramResponse}
                                          setPagination={this.setPagination}
                                          showActions={true}
                                          showCheckbox={true}
                                          selectRow={this.selectRow}
                                          selectedRow={this.state.selectedRow} />

                    </Col>
                </Row>
            </Container>
            )
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/FMKArticles.js